import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ExternalLink } from "lucide-react";

interface AnalysisErrorProps {
  message: string;
  url?: string;
}

export const AnalysisError = ({ message, url }: AnalysisErrorProps) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-grow flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <Alert className="bg-white border-gray-200">
            <AlertTitle className="text-xl font-bold mb-4">Não conseguimos analisar a URL</AlertTitle>
            <AlertDescription className="mt-2 space-y-4">
              <p>
                Nossa tecnologia avançada de análise de páginas encontrou algumas restrições ao tentar acessar este site.
              </p>
              {url && (
                <p className="flex items-center gap-2">
                  Verifique se você consegue acessar:{' '}
                  <a 
                    href={url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 inline-flex items-center gap-1"
                  >
                    {url} <ExternalLink size={16} />
                  </a>
                </p>
              )}
              <p>
                Se você conseguir acessar o site, isso significa que o servidor está bloqueando o acesso automatizado 
                por questões de segurança.
              </p>
              <p>
                Se você é o proprietário do site, recomendamos conversar com sua equipe de tecnologia sobre 
                permitir o acesso para ferramentas de análise SEO.
              </p>
              <Button 
                onClick={() => navigate('/')} 
                className="w-full mt-4 bg-blue-600 hover:bg-blue-700"
              >
                Voltar para página inicial
              </Button>
            </AlertDescription>
          </Alert>
        </div>
      </main>
      <Footer />
    </div>
  );
};